<app-template-text
  [counter]="counter"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [characters]="characters"
  [value]="value"
  [maxlength]="maxlength"
  [control]="control"
  [label]="label"
/>
